<template>
  <aw-spring :desktop-size="10">
    <aw-breadcrumb-version2 :class="$style.breadcrumb" />
    <aw-cms-white-card
      mobile-negative-margin
      :class="$style.card"
    >
      <aw-aggregated-page-cards page-type="news" :params="params" />
    </aw-cms-white-card>
  </aw-spring>
</template>

<script setup lang="ts">
  import { useNuxtApp, useRoute, useAsyncData, useHead } from 'nuxt/app';
  import { AW_AX_CACHE_DEFAULT } from '~~/common/plugins/axios/awAxCache.js';
  import { useSeoStore } from '~~/common/stores/seo.js';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb.js';
  import AwCmsWhiteCard from '~~/common/components/AwCmsWhiteCard.vue';
  import AwBreadcrumbVersion2 from '~~/common/components/Common/AwBreadcrumbVersion2.vue';
  import AwSpring from '~~/common/components/AwSpring.vue';
  import AwAggregatedPageCards from '~~/shop/app/components/Common/AggregatedPages/AwAggregatedPageCards.vue';
  import { computed, provide } from 'vue';
  import { defineI18nRoute } from '#i18n';

  defineOptions({
    name: 'SpecificNewsPage',
  });
  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });
  const {
    $api,
    $awt,
    $logger,
  } = useNuxtApp();
  const route = useRoute();
  const seoStore = useSeoStore();

  // AwAggregatedPageCards → AwCarouselV3 injects getRowIndexById; provide it like
  // the other aggregated-page pages (news/index, csr, press, …) do.
  provide('getRowIndexById', () => 0);

  const title = computed(() => {
    const sTitle = seoStore.getSeoReadonlyTitleParts().value;
    return sTitle.changePrefix(`${$awt('aw.pages.news.title')} - `).joinedTitle();
  });

  useHead({ title });

  const { data: params } = await useAsyncData(
    `${route.params.type}_${route.params.slug}`,
    async () => {
      try {
        const {
          type,
          slug,
        } = route.params;
        const result = await $api.get(`/${type}/${slug}`, { awAxCache: AW_AX_CACHE_DEFAULT });
        return {
          [`${type}Code`]: result.data?.id,
        };
      } catch (error) {
        $logger.error(new Error('Error fetching news data:', { cause: error }));
        return {};
      }
    },
    {
      default: () => ({}),
    },
  );

  const breadcrumbStore = useBreadcrumbStore();

  breadcrumbStore.setBreadcrumbs([
    {
      token: $awt('aw.common.category.home'),
      to: '/',
      disabled: false,
    },
    {
      token: $awt('aw.pages.news.title'),
      to: 'news',
      disabled: true,
    },
  ]);

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/news/[type]/[slug]',
      hu: '/hirek/[type]/[slug]',
    },
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.head {
  display: flex;
  flex-direction: column;
  gap: 20px;

  @include tablet(min) {
    flex-direction: row;
    justify-content: space-between;
  }

  &Search {
    width: 100%;
    @include tablet(min) {
      width: 50%;
      max-width: 520px;
    }
  }
}

.breadcrumb {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}

.card {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}
</style>
